export default {
   "salutation": "",
   "fullname": "",
   "icpassport": "",
   "memberid": "",
   "contactemail": "",
   "contactmobile": "",
   "homestate": "",
   "membertype": "STU",
   "memberstatus": 3,
   "password": ""
}
